import { Box, CardContent, Divider, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import { EntriesSkeletons } from "src/components/cards/custom/common/EntriesSkeletons";
import { isNotLastItem } from "src/components/cards/custom/common/utils";
import { SenecCard } from "src/components/cards/base/SenecCard";

export type Notification = {
    id: string;
    header: string;
    message: ReactElement | string;
};

export interface NotificationsCardProps {
    notifications?: Notification[];
    isLoading: boolean;
    error?: Error;
    title: string;
    noContentMsg: string;
    "data-testid"?: string;
}

export const SenecNotificationsCard = ({
    notifications,
    isLoading,
    error,
    title,
    noContentMsg,
    "data-testid": dataTestId = "notification-card",
}: NotificationsCardProps) => {
    const showSkeletonOrNotifications = () => {
        if (isLoading) {
            return <EntriesSkeletons />;
        } else if (!!error || !notifications || notifications.length < 1) {
            return <Typography>{noContentMsg}</Typography>;
        } else {
            return (
                <>
                    {notifications.map((item: Notification, index: number) => (
                        <Notification key={item.id + index} count={notifications.length} notification={item} index={index} />
                    ))}
                </>
            );
        }
    };

    return (
        <SenecCard data-testid={dataTestId} sx={{ padding: 0, height: "100%" }}>
            <CardContent sx={{ padding: 3 }}>
                <Stack spacing={3}>
                    <Typography variant="h4">{title}</Typography>
                    {showSkeletonOrNotifications()}
                </Stack>
            </CardContent>
        </SenecCard>
    );
};

const Notification = ({ notification, count, index }: { notification: Notification; count: number; index: number }) => {
    return (
        <Box data-testid={`notification`}>
            <Typography variant="h5">{notification.header}</Typography>
            {typeof notification.message === "string" ? (
                <Typography>{notification.message}</Typography>
            ) : (
                <Box marginTop="0.25rem">{notification.message}</Box>
            )}
            {isNotLastItem(count, index) && <Divider sx={{ width: "100%", p: "0.5rem" }} />}
        </Box>
    );
};
